// extracted by mini-css-extract-plugin
export var deliveryRow = "_pw-a";
export var fixedHeight = "_pw-4";
export var freightLogo = "_pw-9";
export var fullWidth = "_pw-3";
export var priceColumn = "_pw-5";
export var radioSelected = "_pw-7";
export var radioUnselected = "_pw-6";
export var selectedOption = "_pw-2";
export var selectedOptionContainer = "_pw-1";
export var selection = "_pw-0";
export var tallSkeletonText = "_pw-8";